import {
  cadOnly as createCadOnlyPlugins,
  full as createFullPlugins,
  fullWithOverlays as createFullWithOverlaysPlugins,
  pointCloudAndGSplat as createPointCloudAndGSplatPlugins,
  pointCloudOnly as createPointCloudOnlyPlugins,
  videoRender as createVideoRenderPlugins,
  type PluginPresetOptions,
  type VideoRenderPluginPresetOptions,
} from '@/plugins/presets'
import type { Plugin } from '@/shared/types/plugin'

export type { PluginPresetOptions, VideoRenderPluginPresetOptions } from '@/plugins/presets'

/**
 * 完整 Plugin 预设，含点云、GSplat、CAD 与交互工具。
 *
 * @returns 预设插件列表
 */
export function full(options?: PluginPresetOptions): Plugin[] {
  return createFullPlugins(options)
}

/**
 * 仅点云查看预设。
 *
 * @returns 预设插件列表
 */
export function pointCloudOnly(options?: PluginPresetOptions): Plugin[] {
  return createPointCloudOnlyPlugins(options)
}

/**
 * 点云 + GSplat 预设。
 *
 * @returns 预设插件列表
 */
export function pointCloudAndGSplat(options?: PluginPresetOptions): Plugin[] {
  return createPointCloudAndGSplatPlugins(options)
}

/**
 * 完整预设并附带 Overlay 工具。
 *
 * @returns 预设插件列表
 */
export function fullWithOverlays(options?: PluginPresetOptions): Plugin[] {
  return createFullWithOverlaysPlugins(options)
}

/**
 * CAD + 点云预设。
 *
 * @returns 预设插件列表
 */
export function cadOnly(options?: PluginPresetOptions): Plugin[] {
  return createCadOnlyPlugins(options)
}

/**
 * 视频渲染预设，仅包含确定性离屏渲染所需插件。
 *
 * @returns 预设插件列表
 */
export function videoRender(options?: VideoRenderPluginPresetOptions): Plugin[] {
  return createVideoRenderPlugins(options)
}
